import { useMutation, useQueryClient } from "@tanstack/react-query";
import { linkProduct, linkSingleProduct } from "./endpoints";
import { getErrorMessage } from "../helpers";
export const useLinkProduct = (customerId, productId) => {
    const queryClient = useQueryClient();
    const { mutate: linkSingleDpad, isLoading: isLinkingSingleDpad, error: linkSingleError } = useMutation({
        mutationFn: async (dpadId) => linkSingleProduct(customerId, productId, dpadId),
        onSuccess: (newProduct) => {
            queryClient.setQueryData(['customer-products', customerId], products => products === null || products === void 0 ? void 0 : products.map(product => product.productId === productId ? newProduct : product));
        },
    });
    const { mutate: linkProductDpads, isLoading: isLinkingProductDpads, error: linkProductError, } = useMutation({
        mutationFn: async (dpadId) => {
            const queryKey = ['customer-products', customerId];
            const products = queryClient.getQueryData(queryKey);
            if (!products) {
                throw new Error('No cached products found');
            }
            const product = products.find(p => p.productId === productId);
            if (!product) {
                throw new Error('Product not found');
            }
            const dpadIdsToLink = product.linkOptions.reduce((acc, option) => {
                if (option.dpadId === dpadId) {
                    if (!option.isLinked) {
                        acc.push(option.dpadId);
                    }
                }
                else {
                    if (option.isLinked) {
                        acc.push(option.dpadId);
                    }
                }
                return acc;
            }, []);
            return linkProduct(customerId, productId, dpadIdsToLink);
        },
        onSuccess: (newProduct) => {
            queryClient.setQueryData(['customer-products', customerId], (products) => products === null || products === void 0 ? void 0 : products.map(p => p.productId === productId ? newProduct : p));
        },
        onSettled: () => {
            queryClient.invalidateQueries(['customer-products', customerId]);
        },
    });
    const linkSingleDpadError = getErrorMessage(linkSingleError);
    const linkProductDpadsError = getErrorMessage(linkProductError);
    return {
        linkSingleDpad,
        linkProductDpads,
        isLinking: isLinkingSingleDpad || isLinkingProductDpads,
        error: linkSingleDpadError || linkProductDpadsError,
    };
};
